export const institutionTypeOptions = [
  { label: 'Select', value: '' },
  { label: 'School', value: 'school' },
  { label: 'College', value: 'college' },
  { label: 'University', value: 'university' },
  { label: 'Training Center', value: 'training_center' }
];
